import { DeferredContent as DeferredContents } from 'primereact/deferredcontent';  

const DeferredContent = ({...rest}) => {

    return (
        <DeferredContents {...rest} />
    )

};

export default DeferredContent;